import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Pseudo from "i18next-pseudo";
import translationEN from "./locales/en-US/translation.json";
import translationES from "./locales/es-ES/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

const lng = localStorage.getItem("language") || "en";

i18n
  .use(
    new Pseudo({
      enabled: false,
      languageToPseudo: "en",
      letterMultiplier: 1,
    }),
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: lng || "en",
    lng: lng || "en",
    postProcess: ["pseudo"],
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        platformName: "",
        supportEmail: "support@outpave.com",
      },
    },
  });

export const setBrandVars = (vars: {
  platformName?: string | null;
  supportEmail?: string | null;
}) => {
  const interpolation = i18n.options.interpolation || {};
  const existing = interpolation.defaultVariables || {};
  const next = {
    ...existing,
    platformName: vars.platformName ?? existing.platformName ?? "",
    supportEmail: vars.supportEmail ?? existing.supportEmail ?? "",
  };
  if (
    next.platformName === existing.platformName &&
    next.supportEmail === existing.supportEmail
  ) {
    return;
  }
  i18n.options.interpolation = { ...interpolation, defaultVariables: next };
  i18n.changeLanguage(i18n.language);
};

export default i18n;
